import { useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";
import { openCalendly } from "../lib/site";

// Public marketing routes where the pinned mobile CTA should appear.
const isPublicMarketing = (pathname) =>
  pathname === "/" || pathname === "/brand-audit" || pathname.startsWith("/pricing/");

export const StickyMobileCTA = () => {
  const { pathname } = useLocation();
  if (!isPublicMarketing(pathname)) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-[#1E2127] bg-[#0A0C0F]/95 px-4 py-3 backdrop-blur-md sm:hidden"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.75rem)" }}
    >
      <button
        onClick={openCalendly}
        data-testid="sticky-book-call-btn"
        className="btn-shine mx-auto flex w-auto items-center justify-center gap-2 rounded-full bg-white px-10 py-3.5 text-sm font-bold uppercase tracking-wider text-[#0A0C0F] transition-colors duration-300 active:bg-[#C6FF00]"
      >
        <Calendar className="h-4 w-4" />
        Book a call
      </button>
    </div>
  );
};

export default StickyMobileCTA;
